module.exports = __webpack_public_path__ + "media/images/illustrations/StarWorks-Hero-BG-e4774584b5eb8c6b129a4577b716bc86.jpg";